import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../../app/Frame';
import { useMeContext } from '../../app/MeContext';
import { useScreen } from '../../app/shell-context';
import { addDaysISO, formatTime, humanISODay, todayISO } from '../../lib/time';
import { plural } from '../../lib/plural';
import { Avatar, Pill } from '../../ui/parts';
import { useCenterDay } from '../api';
import type { AgendaItem } from '../../staff/types';

/** Вкладка «Сегодня»: день организации целиком — все специалисты и их записи. */
export function Center() {
  const me = useMeContext();
  const navigate = useNavigate();
  const tz = me.center.tz;
  const tf = me.center.timeFormat;
  const [date, setDate] = useState(() => todayISO(tz));
  const day = useCenterDay(date);

  useScreen('Сегодня', null);

  const specialists = day.data?.specialists ?? [];
  const all = specialists.flatMap((s) => s.items);
  const live = all.filter((a) => a.status !== 'cancelled' && a.status !== 'no_show');
  const unpaid = live.filter((a) => a.payment_status !== 'paid');
  const active = specialists.filter((s) => s.status === 'active');
  const load = active.length ? Math.round((live.length / (active.length * 6)) * 100) : 0;

  return (
    <Screen>
      <div className="daynav">
        <button type="button" aria-label="Предыдущий день" onClick={() => setDate(addDaysISO(date, -1))}>‹</button>
        <b>{humanISODay(date, tz)}</b>
        <button type="button" aria-label="Следующий день" onClick={() => setDate(addDaysISO(date, 1))}>›</button>
      </div>

      <div className="stats">
        <div className="stat">
          <b>{live.length}</b>
          <span>{plural(live.length, 'запись', 'записи', 'записей')}</span>
        </div>
        <div className="stat">
          <b>{unpaid.length}</b>
          <span>без оплаты</span>
        </div>
        <div className="stat">
          <b>{load}%</b>
          <span>загрузка</span>
        </div>
      </div>

      <p className="eyebrow">Специалисты сегодня</p>
      {day.isPending ? <p className="lead">Загружаем день организации…</p> : null}

      <div className="rows">
        {specialists.map((s) => {
          const items = s.items.filter((a: AgendaItem) => a.status !== 'cancelled');
          return (
            <button className="rw" key={s.id} onClick={() => navigate(`/admin/staff/${s.id}/schedule`)}>
              <Avatar name={s.name} small />
              <span className="rw-body">
                <b>{s.name}</b>
                <span>
                  {s.status === 'paused'
                    ? 'запись приостановлена'
                    : items.length
                      ? `${items.length} ${plural(items.length, 'запись', 'записи', 'записей')} · ${formatTime(items[0].starts_at_utc, tz, tf)} – ${formatTime(items[items.length - 1].ends_at_utc, tz, tf)}`
                      : 'записей нет'}
                </span>
                <span className="load">
                  <i style={{ width: `${Math.min(100, items.length * 16)}%` }} />
                </span>
              </span>
              {s.status === 'paused' ? <Pill kind="off">пауза</Pill> : null}
            </button>
          );
        })}
      </div>

      {!day.isPending && specialists.length === 0 ? (
        <p className="lead">В организации пока нет специалистов.</p>
      ) : null}
    </Screen>
  );
}
